import React, { useState, useRef, useEffect } from 'react'
import { Link, useParams, useHistory } from 'react-router-dom'
import {
  HttpService,
  API,
  SimpleReactValidator,
  Title,
  toast,
  Messages,
  Nestable,
  swal,
  DropdownTreeSelect,
  xmlbuilder,
  Common,
  Permissionkeys,
  Spinner
} from '../../../config/react'

const NavigationMenu = () => {
  const history = useHistory()
  const [IsAuth, setIsAuth] = useState(false)
  const [loading, setLoading] = useState(true)
  const urlParams = useParams()
  // const clearFileRef = useRef()
  const [defaultCollapsed] = useState(true)
  const [Categories, setCategories] = useState([])
  const [DiamondShapeCategories, setDiamondShapeCategories] = useState([])
  const [Pages, setPages] = useState([])
  const [Menus, setMenus] = useState([])
  const [DisabledMenus, setDisabledMenus] = useState([])
  const [MenuItems, setMenuItems] = useState([])
  const [IsDisabledSubmitButton, setIsDisabledSubmitButton] = useState(true)
  // const [MenuItemSortOrders, setMenuItemSortOrders] = useState([])
  const validator = useRef(new SimpleReactValidator())
  const CustomLinkValidator = useRef(new SimpleReactValidator())

  const [MenuItemImage] = useState('')
  const [isForceUpdate, setForceUpdate] = useState(false)

  const [BlogList, setBlogList] = useState([])

  let MenuItemSortOrders = []
  const clearInputs = {
    id: 0,
    title: '',
    description: '',
    menu_type: '',
    link: '',
    category_id: 0,
    page_id: 0,
    // image: "",
    css_class: '',
    parent_id: 0,
    sort_order: '',
    menu_column: 0,
    parameters: null,
    status: 0
  }
  const [Inputs, setInputs] = useState(clearInputs)
  //   useEffect(() => {
  //     setForceUpdate(!isForceUpdate)
  // }, [Menus])
  useEffect(() => {
    if (!Common.validatePermission(Permissionkeys.System)) {
      history.push('/')
    }
    setIsAuth(true)
    setForceUpdate(!isForceUpdate)
    document.title = Title.NavigationMenu

    if (urlParams.id !== undefined) {
      document.title = Title.EditNavigationMenu
      GetNavigationMenuDetail()
    } else {
      clearForm()
    }
    GetCategoryList()
    GetPageList()
    GetMenuItems()
    GetBlogs()
  }, [urlParams.id])

  const GetNavigationMenuDetail = () => {
    const param = {
      id: urlParams.id
    }
    setLoading(true)
    HttpService.postApi(API.GetNavigationMenuDetail, param).then((response) => {
      setLoading(false)
      if (response.data.result) {
        const data = response.data.result
        Object.keys(data[0]).map(function (key, value) {
          Inputs[key] = data[0][key]
          return true
        })

        setInputs(data[0])
        GetCategoryList()

        // setsvgUrl(data[0].image);
        setForceUpdate(!isForceUpdate)
      }
    })
  }

  const GetCategoryList = (selectedCategory = null) => {
    setLoading(true)
    HttpService.postApi(API.GetCategory, null).then((response) => {
      setLoading(false)
      if (response.data.result) {
        // filter parent category
        const parentCategories = response.data.result[0].filter(
          (x) => x.parent_id === 1 && x.status
        )
        setDiamondShapeCategories(
          response.data.result[0].filter((x) => x.is_diamond_category === 1)
        )
        // console.log(parentCategories)
        const categories = []

        parentCategories.map((item) => {
          // filter sub categories by parent
          const filteredSubcategories = response.data.result[0].filter(
            (x) => x.parent_id === item.id && x.status
          )
          const subcategories = []

          filteredSubcategories.map((subitem) => {
            // filter sub child categories by parent
            const filteredSubChildCategories = response.data.result[0].filter(
              (x) => x.parent_id === subitem.id && x.status
            )
            const subchildcategories = []

            filteredSubChildCategories.map((subchilditem) => {
              const filteredChildCategories = response.data.result[0].filter(
                (x) => x.parent_id === subchilditem.id && x.status
              )
              const childcategories = []

              filteredChildCategories.map((childitem) => {
                const filteredChildrenCategories = response.data.result[0].filter(
                  (x) => x.parent_id === childitem.id && x.status
                )
                const childrencategories = []
                filteredChildrenCategories.map((childrenitem) => {
                  let checked = false
                  if (
                    (urlParams.id !== undefined && Inputs.category_id === childrenitem.id) ||
                    selectedCategory === childrenitem.id
                  )
                    checked = true
                  childrencategories.push({
                    label: childrenitem.name,
                    value: childrenitem.id,
                    checked
                    // children: subcategories
                  })
                  return true
                })

                let checked = false
                if (
                  (urlParams.id !== undefined && Inputs.category_id === childitem.id) ||
                  selectedCategory === childitem.id
                )
                  checked = true
                childcategories.push({
                  label: childitem.name,
                  value: childitem.id,
                  checked,
                  children: childrencategories
                })
                return true
              })

              let checked = false
              if (
                (urlParams.id !== undefined && Inputs.category_id === subchilditem.id) ||
                selectedCategory === subchilditem.id
              )
                checked = true
              subchildcategories.push({
                label: subchilditem.name,
                value: subchilditem.id,
                checked,
                children: childcategories
              })
              return true
            })

            let checked = false
            if (
              (urlParams.id !== undefined && Inputs.category_id === subitem.id) ||
              selectedCategory === subitem.id
            )
              checked = true
            subcategories.push({
              label: subitem.name,
              value: subitem.id,
              checked,
              children: subchildcategories
            })
            return true
          })
          let checked = false
          if (
            (urlParams.id !== undefined && Inputs.category_id === item.id) ||
            selectedCategory === item.id
          )
            checked = true
          categories.push({
            label: item.name,
            value: item.id,
            children: subcategories,
            checked
          })
          return true
        })
        setCategories(categories)
      }
    })
  }

  const GetMenuItems = () => {
    setLoading(true)
    HttpService.getApi(API.GetAdminNavigationMenuList).then((response) => {
      setLoading(false)
      // console.log(response);
      const data = response.data.result[0].filter((item) => item.status)
      const disabled = response.data.result[0].filter((item) => item.status === 0)
      setDisabledMenus(disabled)
      setMenus(data)
      // filter 1st level menu items
      const parentMenu = data.filter((x) => x.parent_id === 0)
      const menuItems = []
      // sort menu on sort_order field
      parentMenu
        .sort(({ sort_order: previousID }, { sort_order: currentID }) => previousID - currentID)
        .map((item) => {
          // filter 2nd level menu items
          const subMenu = data.filter((x) => x.parent_id === item.id)
          const children = []
          // sort menu on sort_order field
          subMenu
            .sort(({ sort_order: previousID }, { sort_order: currentID }) => previousID - currentID)
            .map((subItem) => {
              // filter 3rd level menu items
              const childMenu = data.filter((x) => x.parent_id === subItem.id)
              const subChildren = []
              childMenu
                .sort(
                  ({ sort_order: previousID }, { sort_order: currentID }) => previousID - currentID
                )
                .map((subChildItem) => {
                  // filter 4th level menu items
                  const subChildMenu = data.filter((x) => x.parent_id === subChildItem.id)
                  const children = []
                  subChildMenu
                    .sort(
                      ({ sort_order: previousID }, { sort_order: currentID }) =>
                        previousID - currentID
                    )
                    .map((childItem) => {
                      children.push({
                        id: childItem.id,
                        text: childItem.title,
                        slug: childItem.slug,
                        css_class: childItem.css_class,
                        updated_at: childItem.updated_at,
                        page_update_priority: childItem.page_update_priority
                      })
                      return true
                    })

                  subChildren.push({
                    id: subChildItem.id,
                    text: subChildItem.title,
                    children,
                    image: subChildItem.image,
                    slug: subChildItem.slug,
                    updated_at: subChildItem.updated_at,
                    css_class: subChildItem.css_class,
                    page_update_priority: subChildItem.page_update_priority
                  })
                  return true
                })
              children.push({
                id: subItem.id,
                text: subItem.title,
                children: subChildren,
                image: subItem.image,
                slug: subItem.slug,
                updated_at: subItem.updated_at,
                css_class: subItem.css_class,
                page_update_priority: subItem.page_update_priority
              })
              return true
            })
          menuItems.push({
            id: item.id,
            text: item.title,
            children,
            image: item.image,
            slug: item.slug,
            updated_at: item.updated_at,
            css_class: item.css_class,
            page_update_priority: item.page_update_priority
          })
          return true
        })

      setMenuItems(menuItems)
    })
  }

  const GetPageList = () => {
    setLoading(true)
    HttpService.getApi(API.GetContentManagementList).then((response) => {
      setLoading(false)
      let data = response.data.result
      data = data.filter((item) => item.status === 1)
      setPages(data)
    })
  }

  const styles = {
    position: 'relative',
    padding: '10px 15px',
    fontSize: '15px',
    border: '1px solid #f9fafa',
    background: '#f9fafa',
    cursor: 'pointer'
  }
  const disabledstyles = {
    // position: 'relative',
    padding: '10px 15px',
    fontSize: '15px',
    border: '1px solid #f9fafa',
    background: '#f9fafa',
    cursor: 'pointer'
  }

  const renderItem = (item) => {
    // console.log(item);
    return (
      <div style={styles}>
        {item.handler}
        {item.collapseIcon}
        {/* <img className={item.css_class} src={item.item.image} width="100" /> */}
        <span className={'menu-icon nav-' + item.item.css_class}></span>
        {item.item.text}
        <Link
          to="#"
          onClick={(e) => deleteMenuItem(e, item.item.id)}
          className="text-dark float-right"
          title="Delete"
        >
          <i
            className="fa fa-trash-o"
            aria-hidden="true"
          ></i>{' '}
        </Link>
        <Link
          to={'/system/navigation-menu/edit/' + item.item.id}
          className="text-dark float-right mr-2"
          title="Edit"
        >
          <i
            className="fa fa-pencil-square-o"
            aria-hidden="true"
          ></i>{' '}
        </Link>
      </div>
    )
  }
  const renderDisableItem = (item) => {
    return (
      <div style={disabledstyles}>
        {item.handler}
        {item.collapseIcon}
        {/* <img className={item.css_class} src={item.item.image} width="100" /> */}
        <span className={'menu-icon nav-' + item.item.css_class}></span>
        {item.item.title}
        <Link
          to="#"
          onClick={(e) => deleteMenuItem(e, item.item.id)}
          className="text-dark float-right"
          title="Delete"
        >
          <i
            className="fa fa-trash-o"
            aria-hidden="true"
          ></i>{' '}
        </Link>
        <Link
          to={'/system/navigation-menu/edit/' + item.item.id}
          className="text-dark float-right mr-2"
          title="Edit"
        >
          <i
            className="fa fa-pencil-square-o"
            aria-hidden="true"
          ></i>{' '}
        </Link>
      </div>
    )
  }

  const changeMenu = (menu) => {
    const menuItems = []
    menu.items.map((item, index) => {
      // 1st level menu items
      menuItems.push({ id: item.id, parent_id: 0, sort_order: index })

      // 2nd level menu items
      if (item.children) {
        item.children.map((subItem, subIndex) => {
          menuItems.push({ id: subItem.id, parent_id: item.id, sort_order: subIndex })

          // 3rd level menu items
          if (subItem.children) {
            subItem.children.map((subChildItem, subChildIndex) => {
              menuItems.push({
                id: subChildItem.id,
                parent_id: subItem.id,
                sort_order: subChildIndex
              })

              // 4th level menu items
              if (subChildItem.children) {
                subChildItem.children.map((childItem, childIndex) => {
                  menuItems.push({
                    id: childItem.id,
                    parent_id: childItem.id,
                    sort_order: childIndex
                  })
                  return true
                })
              }
              return true
            })
          }
          return true
        })
      }
      return true
    })

    MenuItemSortOrders = menuItems
    setIsDisabledSubmitButton(false)
    // setMenuItemSortOrders( menuItems)
  }

  const deleteMenuItem = (event, menuId) => {
    swal(Messages.SwalDeleteProp).then(function (isConfirm) {
      if (isConfirm) {
        const param = {
          id: menuId
        }
        setLoading(true)
        HttpService.postApi(API.DeleteNavigationMenuItem, param).then((response) => {
          setLoading(true)
          GetMenuItems()
        })
      }
    })
  }

  const clearForm = (e) => {
    setInputs(clearInputs)
    // inputFile.current.value = ''
    // setsvgUrl()
    // clearFileRef.current.click();
    setForceUpdate(!isForceUpdate)
  }

  const handleInputChanges = (e) => {
    const field = e.target.name
    const fieldval = e.target.value

    if (field === 'status') setInputs({ ...Inputs, [field]: e.target.checked })
    else setInputs({ ...Inputs, [field]: fieldval })
    setForceUpdate(!isForceUpdate)
    updateCategoryDropdown()
  }

  const AddMenuItem = (e) => {
    if (!validator.current.allValid()) {
      validator.current.showMessages()
      if (Inputs.menu_type === 'custom_link') {
        ValidateCustomLink()
      }
      setForceUpdate(!isForceUpdate)
      return
    }
    if (Inputs.menu_type === 'custom_link') {
      ValidateCustomLink()
    }
    const param = {
      id: Inputs.id,
      title: Inputs.title,
      description: Inputs.description,
      menu_type: Inputs.menu_type,
      link: Inputs.link,
      category_id: Inputs.category_id,
      page_id: Inputs.page_id,
      image: MenuItemImage,
      css_class: Inputs.css_class,
      status: Inputs.status,
      parent_id: Inputs.parent_id,
      menu_column: Number(Inputs.menu_column),
      parameters: Inputs.parameters ?? '',
      sort_order: Inputs.sort_order
    }
    // console.log(param);
    if (urlParams.id === undefined) {
      setLoading(true)
      HttpService.postApi(API.AddNavigationMenuItem, param).then((response) => {
        setLoading(false)
        if (response.data.result !== null) {
          const menuId = response.data.result[0][0].result
          const menuItems = MenuItems
          menuItems.push({ id: menuId, text: Inputs.title })
          setMenuItems(menuItems)
          GetMenuItems()
          validator.current.hideMessages()
          clearForm()
          validator.current.hideMessages()
          toast.success(Messages.MenuAdded)
          setForceUpdate(!isForceUpdate)
          window.scrollTo(0, 0)
        }
      })
    } else {
      setLoading(true)
      HttpService.postApi(API.UpdateNavigationMenu, param).then((response) => {
        setLoading(false)
        if (response !== null) {
          GetMenuItems()
          validator.current.hideMessages()
          toast.success(Messages.MenuUpdated)
          validator.current.hideMessages()
          window.scrollTo(0, 0)
        }
      })
    }
  }

  const ValidateCustomLink = (e) => {
    if (!CustomLinkValidator.current.allValid()) {
      CustomLinkValidator.current.showMessages()
      setForceUpdate(!isForceUpdate)
    }
  }

  const SubmitMenu = (e) => {
    const param = {
      menu_items: MenuItemSortOrders
    }
    setLoading(true)
    HttpService.postApi(API.UpdateNavigationMenuOrder, param).then((response) => {
      setLoading(false)
      if (response.data.message) {
        toast.warning(response.data.message)
        setForceUpdate(!isForceUpdate)
        return
      }
      validator.current.hideMessages()
      GetMenuItems()
      toast.success(Messages.MenuUpdated)
      // setForceUpdate(!isForceUpdate);
    })
  }
  const GetBlogs = (e) => {
    const param = {
      page: 0,
      search: '',
      page_size: 0,
      sort_column: '',
      sort_direction: ''
    }
    setLoading(true)
    HttpService.postApi(API.GetBlogs, param).then((response) => {
      setLoading(false)
      if (response.data.status === true && response.data.result !== '') {
        setBlogList(response.data.result[1])
        setForceUpdate(!isForceUpdate)
      } else {
        setBlogList([])
      }
    })
  }
  const onChangeCategory = (currentNode, selectedNodes) => {
    if (selectedNodes.length > 0) {
      Inputs.category_id = selectedNodes[0].value
    }
    // setForceUpdate(!isForceUpdate)
  }

  const updateCategoryDropdown = (e) => {
    Categories.map((item, index) => {
      if (item.value === Inputs.category_id) {
        Categories[index].checked = true
      } else {
        Categories[index].checked = false
      }
      if (item.children) {
        item.children.map((subitem, subindex) => {
          if (subitem.value === Inputs.category_id) {
            Categories[index].children[subindex].checked = true
          } else {
            Categories[index].children[subindex].checked = false
          }
          return true
        })
      }
      return true
    })
  }
  // window.addEventListener("fileUploadWithPreview:imagesAdded", function (e) {
  //     // setsvgUrl(e.detail.cachedFileArray[0])
  //     // var fileName = e.detail.cachedFileArray[0].name
  //     // var fileExtension = ['png','jpg','jpeg','bmp']
  //     // var regex = /(?:\.([^.]+))?$/;
  //     // var ext = regex.exec(fileName)[1];
  //     // console.log(fileExtension.indexOf(ext) > -1)
  //     // if(fileExtension.indexOf(ext) > -1){
  //     //     getBase64(e.detail.cachedFileArray[0], (result) => {
  //     //         setMenuItemImage(result)
  //     //     });
  //     //     setIsShowImageRemoveLink(true)
  //     //     updateCategoryDropdown()
  //     // }
  //     // else{
  //     // }
  //     getBase64(e.detail.cachedFileArray[0], (result) => {
  //         // setsvgUrl(result)
  //         setMenuItemImage(result)
  //         setForceUpdate(!isForceUpdate)
  //     });
  //     setIsShowImageRemoveLink(true)
  //     updateCategoryDropdown()

  // });
  // window.addEventListener("fileUploadWithPreview:clearButtonClicked", function (e) {
  //     setMenuItemImage('')
  //     setIsShowImageRemoveLink(false)
  //     updateCategoryDropdown()
  // });
  const generateSitemap = () => {
    const urls = []
    const frontendUrl = process.env.REACT_APP_FRONTEND_URL.replace(/\/$/, '')
    const staticLinks = [
      { url: frontendUrl + '/contact-us', priority: 1.0, lastmod: 'daily' },
      { url: frontendUrl + '/blogs', priority: 1.0, lastmod: 'daily' },
      { url: frontendUrl + '/ring-size-chart', priority: 1.0, lastmod: 'daily' }
    ]

    let xml = xmlbuilder.create('urlset')
    xml.att('xmlns', 'http://www.sitemaps.org/schemas/sitemap/0.9')
    xml.att('xmlns:xhtml', 'http://www.w3.org/1999/xhtml')

    xml
      .ele('url')
      .ele('loc', frontendUrl)
      .up()
      .ele('lastmod', 'daily')
      .up()
      .ele('priority', 1.0)
      .up()
      .end({ pretty: true })
    urls.push(frontendUrl)
    MenuItems.map((item, index) => {
      const pageUpdatePriority =
        item.page_update_priority !== null &&
        item.page_update_priority !== 'null' &&
        item.page_update_priority !== '' &&
        !item.slug.includes('?')
          ? item.page_update_priority
          : 0.8
      const lastMod = pageUpdatePriority === 1 ? 'daily' : item.updated_at
      if (
        item.slug !== null &&
        !urls.includes(item.slug) &&
        !item.slug.includes('?') &&
        pageUpdatePriority >= 0
      ) {
        xml
          .ele('url')
          .ele('loc', frontendUrl + item.slug)
          .up()
          .ele('lastmod', lastMod)
          .up()
          .ele('priority', pageUpdatePriority)
          .up()
          .end({ pretty: true })
        urls.push(item.slug)
      }
      if (item.children.length > 0) {
        item.children.map((subitem, subindex) => {
          const pageUpdatePriority =
            subitem.page_update_priority !== null &&
            subitem.page_update_priority !== 'null' &&
            subitem.page_update_priority !== '' &&
            !subitem.slug.includes('?')
              ? subitem.page_update_priority
              : 0.8
          const lastMod = pageUpdatePriority === 1 ? 'daily' : subitem.updated_at
          if (
            subitem.slug !== null &&
            !urls.includes(subitem.slug) &&
            !subitem.slug.includes('?') &&
            pageUpdatePriority >= 0
          ) {
            xml
              .ele('url')
              .ele('loc', frontendUrl + subitem.slug)
              .up()
              .ele('lastmod', lastMod)
              .up()
              .ele('priority', pageUpdatePriority)
              .up()
              .end({ pretty: true })
            urls.push(subitem.slug)
          }
          if (subitem.children.length > 0) {
            subitem.children.map((childitem, childindex) => {
              const pageUpdatePriority =
                childitem.page_update_priority !== null &&
                childitem.page_update_priority !== 'null' &&
                childitem.page_update_priority !== '' &&
                !childitem.slug.includes('?')
                  ? childitem.page_update_priority
                  : 0.8
              const lastMod = pageUpdatePriority === 1 ? 'daily' : childitem.updated_at
              if (
                childitem.slug !== null &&
                !urls.includes(childitem.slug) &&
                !childitem.slug.includes('?') &&
                pageUpdatePriority >= 0
              ) {
                xml
                  .ele('url')
                  .ele('loc', frontendUrl + childitem.slug)
                  .up()
                  .ele('lastmod', lastMod)
                  .up()
                  .ele('priority', pageUpdatePriority)
                  .up()
                  .end({ pretty: true })
                urls.push(childitem.slug)
              }
              return true
            })
          }
          return true
        })
      }
      return true
    })

    Pages.map((item, index) => {
      if (!urls.includes(item.slug) && item.slug !== '/notfound') {
        const pageUpdatePriority =
          item.page_update_priority !== null &&
          item.page_update_priority !== 'null' &&
          item.page_update_priority !== ''
            ? item.page_update_priority
            : 0.8
        const lastMod = pageUpdatePriority === 1 ? 'daily' : item.updated_at
        if (pageUpdatePriority >= 0)
          xml
            .ele('url')
            .ele('loc', frontendUrl + item.slug)
            .up()
            .ele('lastmod', lastMod)
            .up()
            .ele('priority', pageUpdatePriority)
            .up()
            .end({ pretty: true })
      }
      return true
    })
    /* Add custom link */
    DiamondShapeCategories.map((item, index) => {
      // console.log(item.slug);
      if (!urls.includes(item.slug)) {
        const pageUpdatePriority =
          item.page_update_priority !== null &&
          item.page_update_priority !== 'null' &&
          item.page_update_priority !== ''
            ? item.page_update_priority
            : 0.8
        const lastMod =
          pageUpdatePriority === 1
            ? 'daily'
            : item.updated_at !== null
              ? item.updated_at
              : item.created_at
        if (pageUpdatePriority >= 0)
          xml
            .ele('url')
            .ele('loc', frontendUrl + item.slug)
            .up()
            .ele('lastmod', lastMod)
            .up()
            .ele('priority', pageUpdatePriority)
            .up()
            .end({ pretty: true })
      }
      return true
    })
    staticLinks.map((item, index) => {
      xml
        .ele('url')
        .ele('loc', item.url)
        .up()
        .ele('lastmod', item.lastmod)
        .up()
        .ele('priority', item.priority)
        .up()
        .end({ pretty: true })
      return true
    })
    BlogList.map((item, index) => {
      const lastMod = item.updated_at !== null ? item.updated_at : item.created_at
      xml
        .ele('url')
        .ele('loc', frontendUrl + '/blog/' + item.slug)
        .up()
        .ele('lastmod', lastMod)
        .up()
        .ele('priority', 0.8)
        .up()
        .end({ pretty: true })
      return true
    })

    xml = xml.end({ pretty: true })
    const param = {
      content: xml
    }
    setLoading(true)
    HttpService.postApi(API.GenerateSitemap, param).then((response) => {
      setLoading(false)
      if (response.data.status) {
        swal({
          title: Messages.SitemapGenerated
        })
      }
    })
    return true
  }

  return !IsAuth || loading ? (
    <Spinner />
  ) : (
    <div className="content-wrapper pb-0">
      <div className="page-header">
        <h3 className="page-title mb-0 d-flex align-items-center">
          {' '}
          {Title.NavigationMenu}{' '}
          {Inputs.title ? <small className="ml-2 mb-0">({Inputs.title})</small> : ''}{' '}
        </h3>
        <div className="btn-group">
          <button
            type="button"
            className="btn btn-dark btn-fw rounded mr-2"
            onClick={generateSitemap}
          >
            Generate Sitemap
          </button>
          {urlParams.id !== undefined && (
            <Link
              to="/system/navigation-menu"
              className="btn btn-dark btn-fw rounded mr-2"
            >
              {' '}
              New Menu{' '}
            </Link>
          )}
        </div>
      </div>
      <div className="row">
        <div className="col-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <form className="forms-sample">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Title</label>
                      <input
                        type="text"
                        className="form-control"
                        name="title"
                        onChange={handleInputChanges}
                        value={Inputs.title || ''}
                        placeholder="Title"
                      />
                      {validator.current.message('Title', Inputs.title, 'required|max:50', {
                        className: 'error'
                      })}
                    </div>
                    <div className="form-group">
                      <label>Description</label>
                      <input
                        type="text"
                        className="form-control"
                        name="description"
                        onChange={handleInputChanges}
                        value={Inputs.description || ''}
                        placeholder="Description"
                      />
                      {validator.current.message(
                        'Description',
                        Inputs.description,
                        'required|max:1000',
                        { className: 'error' }
                      )}
                    </div>
                    <div className="form-group">
                      <label>Menu Type</label>
                      <select
                        className="form-control"
                        name="menu_type"
                        onChange={handleInputChanges}
                        value={Inputs.menu_type}
                      >
                        <option value="">Select</option>
                        <option value="category">Category</option>
                        <option value="page">Page</option>
                        <option value="custom_link">Custom Link</option>
                        <option value="blank">Blank</option>
                      </select>
                      {/* {validator.current.message('Menu Type', Inputs.menu_type, 'required', { className: 'error' })} */}
                    </div>
                    <div
                      className="form-group"
                      style={Inputs.menu_type === 'category' ? {} : { display: 'none' }}
                    >
                      <label>Category</label>
                      {Categories.length > 0 && (
                        <DropdownTreeSelect
                          multi={false}
                          data={Categories}
                          onChange={onChangeCategory}
                          mode="radioSelect"
                          className="bootstrap-demo"
                          texts={{ placeholder: 'Select' }}
                        />
                      )}
                    </div>
                    <div
                      className="form-group"
                      style={Inputs.menu_type === 'page' ? {} : { display: 'none' }}
                    >
                      <label>Page</label>
                      <select
                        className="form-control"
                        name="page_id"
                        onChange={handleInputChanges}
                        value={Inputs.page_id}
                      >
                        {Pages.map((item) => (
                          <option
                            key={item.id}
                            value={item.id}
                          >
                            {item.title}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div
                      className="form-group"
                      style={Inputs.menu_type === 'custom_link' ? {} : { display: 'none' }}
                    >
                      <label>Custom Link</label>
                      <input
                        type="text"
                        className="form-control"
                        name="link"
                        onChange={handleInputChanges}
                        value={Inputs.link || ''}
                        placeholder="Custom Link"
                      />
                      {CustomLinkValidator.current.message(
                        'Custom Link',
                        Inputs.link,
                        'required|max:255',
                        { className: 'error' }
                      )}
                    </div>
                    <div className="form-group">
                      <label>Parent</label>
                      <select
                        className="form-control"
                        name="parent_id"
                        onChange={handleInputChanges}
                        value={Inputs.parent_id}
                      >
                        <option value="0">Choose</option>
                        {Menus.map((item) => (
                          <option
                            key={item.id}
                            value={item.id}
                          >
                            {item.parent_menu !== '' && item.parent_menu !== null
                              ? item.title + ' - ' + item.parent_menu
                              : item.title}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group">
                      <label>Sort Order</label>
                      <input
                        type="number"
                        className="form-control"
                        name="sort_order"
                        onChange={handleInputChanges}
                        value={Inputs.sort_order}
                        placeholder="Sort Order"
                        min="0"
                      />
                      {validator.current.message(
                        'Sort Order',
                        Inputs.sort_order,
                        'required|numeric|min:0,num',
                        { className: 'error' }
                      )}
                    </div>
                    <div className="form-group">
                      <label>Menu Column</label>
                      <input
                        type="number"
                        className="form-control"
                        name="menu_column"
                        onChange={handleInputChanges}
                        value={Inputs.menu_column || ''}
                        placeholder="Menu Column"
                        min="0"
                      />
                    </div>
                    <div className="form-group">
                      <label>Parameters</label>
                      <input
                        type="text"
                        className="form-control"
                        name="parameters"
                        onChange={handleInputChanges}
                        value={Inputs.parameters || ''}
                        placeholder="Parameters"
                      />
                    </div>
                    <div className="form-group">
                      <label>
                        Image Name for Menu
                        <svg
                          data-toggle="tooltip"
                          data-html="true"
                          title="Add class name for individual icon. Ex:1. 'icon-1(row 1)-1(col 1)' look like class name 'icon-1-1', Ex:2. 'icon-1(row 1)-2(col 2)' look like class name 'icon-1-2'  <br> <img src='https://hjl.s3.eu-west-2.amazonaws.com/assets/images/info-sprit-icon.png'>"
                          xmlns="http://www.w3.org/2000/svg"
                          width="17"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#000000d4"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="feather feather-info ml-1 cursor"
                        >
                          <circle
                            cx="12"
                            cy="12"
                            r="10"
                          ></circle>
                          <line
                            x1="12"
                            y1="16"
                            x2="12"
                            y2="12"
                          ></line>
                          <line
                            x1="12"
                            y1="8"
                            x2="12.01"
                            y2="8"
                          ></line>
                        </svg>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="css_class"
                        onChange={handleInputChanges}
                        value={Inputs.css_class || ''}
                        placeholder="CSS Class"
                      />
                      {validator.current.message('CSS Class', Inputs.css_class, 'max:200', {
                        className: 'error'
                      })}
                    </div>
                    <div className="form-group row">
                      <label
                        htmlFor="exampleInputUsername2"
                        className="col-sm-12"
                      >
                        Status
                      </label>
                      <div className="col-sm-12">
                        <div className="custom-control custom-switch mt-1">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            name="status"
                            onChange={handleInputChanges}
                            id="EnableMenu"
                            checked={Inputs.status}
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="EnableMenu"
                          >
                            {' '}
                          </label>
                        </div>
                      </div>
                    </div>

                    <button
                      type="button"
                      onClick={AddMenuItem}
                      className="btn btn-custom text-white mt-5 mr-2"
                    >
                      {' '}
                      {urlParams.id === undefined ? 'Add to Menu' : 'Update Menu'}{' '}
                    </button>
                  </div>
                  <div className="col-md-6">
                    <div className="col-md-12">
                      <Nestable
                        items={MenuItems}
                        renderItem={renderItem}
                        collapsed={defaultCollapsed}
                        onChange={changeMenu}
                        maxDepth={4}
                        // collapsed={true}
                      />
                    </div>

                    <div className="col-md-12 mb-5">
                      <button
                        type="button"
                        onClick={SubmitMenu}
                        className="btn btn-custom text-white mr-2 float-right mt-4"
                        disabled={IsDisabledSubmitButton}
                      >
                        {' '}
                        Save Menu{' '}
                      </button>
                    </div>
                    <div className="col-md-12">
                      <label className="mt-5">Disabled Menus</label>
                      <Nestable
                        className="customNestable"
                        items={DisabledMenus}
                        renderItem={renderDisableItem}
                        collapsed={defaultCollapsed}
                        // onChange={changeMenu}
                      />
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NavigationMenu
